export const COMMON_AUTOCOMPLETE_PROPS = {
	AUTOCOMPLETE_OFF: 'off',
	AUTOCAPITALIZE_OFF: 'off',
	AUTOCORRECT_OFF: 'off',
};
